module.exports = __webpack_public_path__ + "f0d7e8514dd542e425fb18c06385c686.svg";